import { render, staticRenderFns } from "./flowInfo.vue?vue&type=template&id=25d72e06&"
import script from "./flowInfo.vue?vue&type=script&lang=js&"
export * from "./flowInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/flow/flowInfo.vue"
export default component.exports